import { useEffect, useState } from "react";
import { format } from "date-fns";
import { Loader2 } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import api from "@/lib/api";

const OUTCOME_STYLES = {
  success: "bg-ukgreen-light text-ukgreen border-transparent",
  denied: "bg-amber-100 text-amber-800 border-transparent",
  failure: "bg-red-50 text-red-700 border-transparent",
};

export default function AuditTab({ child }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/audit-logs", { params: { resource_id: child.id, limit: 100 } })
      .then((r) => setItems(r.data.items))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [child.id]);

  const fmt = (v) => {
    try {
      return format(new Date(v), "dd MMM yyyy HH:mm");
    } catch {
      return "";
    }
  };

  return (
    <Card data-testid="child-audit-tab">
      <CardHeader><CardTitle className="text-lg">Case audit history</CardTitle></CardHeader>
      <CardContent>
        {loading ? (
          <div className="flex items-center gap-2 text-slate-600"><Loader2 className="h-4 w-4 animate-spin" /> Loading…</div>
        ) : items.length === 0 ? (
          <p className="text-sm text-slate-600" data-testid="child-audit-empty">No audit entries recorded against this case yet.</p>
        ) : (
          <ul className="divide-y divide-border" data-testid="child-audit-list">
            {items.map((a) => (
              <li key={a.id} className="py-2.5 flex flex-wrap items-center gap-2" data-testid={`child-audit-${a.id}`}>
                <Badge className={OUTCOME_STYLES[a.outcome] || ""}>{a.outcome}</Badge>
                <span className="text-sm font-medium text-slate-800">{a.action}</span>
                <span className="text-xs text-slate-500">{a.actor_email || "system"}</span>
                <span className="text-xs text-slate-400 ml-auto">{fmt(a.created_at)}</span>
                {a.detail && <p className="w-full text-xs text-slate-600">{a.detail}</p>}
              </li>
            ))}
          </ul>
        )}
      </CardContent>
    </Card>
  );
}
